export default {
    // URL of the RESTful API
    "apiBaseUrl": "http://192.168.0.80:5000"
}